var AdjustHeight = {
    conf: {
        animSpeed: 400,
        headHeight: 0
    },
    init: function(n, elem) {
        var self = this;
        var conf = self.conf;
        switch(n) {
            case "":
                var h = self.getHighestHeight(elem);
                self.setHeight(elem, h);
                break;
        }
    },
    getHighestHeight: function(elem) {
        // console.log("getHighestHeight");
        // console.log($(elem));
        var hh = 0;
        $(elem).each(function(index, element) {
            $(element).css({'height': 'auto'});
            var h = $(element).outerHeight();
            if(hh < h) hh = h;
            // console.log($(element).outerHeight());
        });
        return hh;
    },
    setHeight: function(elem,height) {
        $(elem).each(function(index, element) {
            $(element).css({'height': height +'px'});
        });
    }
};

module.exports = AdjustHeight;